/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Nav_NewsInputs */

const ja_playdata_nav_news = /** @type {(inputs: Playdata_Nav_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ニュース`)
};

const en_playdata_nav_news = /** @type {(inputs: Playdata_Nav_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News`)
};

/**
* | output |
* | --- |
* | "News" |
*
* @param {Playdata_Nav_NewsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_nav_news = /** @type {((inputs?: Playdata_Nav_NewsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Nav_NewsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_nav_news(inputs)
	return en_playdata_nav_news(inputs)
});